<form [formGroup]="filtersForm" class="grid align-items-end row-gap-1 mt-2">
  <div class="col-12 lg:col-3">
    <span class="font-bold block mb-2">Interval căutare</span>
    <p-calendar
      styleClass="w-full"
      dateFormat="dd/mm/yy"
      selectionMode="range"
      formControlName="interval"
      [showIcon]="true"
      [showOnFocus]="true"
      [placeholder]="'Data de la'"
      [panelStyle]="{
        'height': '439px'
      }"
    ></p-calendar>
  </div>

  <div class="col-12 sm:col-3">
    <span class="font-bold block mb-1">Lockere</span>
    <p-multiSelect
      formControlName="lockers"
      optionLabel="name"
      optionValue="id"
      placeholder="Filtrează lockere"
      styleClass="w-full"
      appendTo="body"
      filterBy="id,name"
      [options]="lockers()"
      [loading]="!lockers()"
    >
      <ng-template let-locker pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>
            <small class="text-gray-400">#{{ locker?.id }}</small>
            <p class="m-0">{{ locker?.name }}</p>
          </div>
        </div>
      </ng-template>
    </p-multiSelect>
  </div>

  <div class="col-12 sm:col-3">
    <span class="font-bold block mb-1">Agenți</span>
    <p-multiSelect
      formControlName="agents"
      optionLabel="name"
      optionValue="identifier"
      placeholder="Filtrează agenti"
      styleClass="w-full"
      appendTo="body"
      [options]="agents()"
      [loading]="!agents()"
    />
  </div>

  <div class="
    col-12 flex-order-0
    lg:flex-order-1 lg:col-3
    text-right
  ">
    <p-button
      label="Generează raport"
      icon="pi pi-file-plus"
      (onClick)="generateReport()"
    ></p-button>
  </div>
</form>

<p-table
  styleClass="p-datatable-sm p-datatable-striped w-full"
  currentPageReportTemplate="{first} - {last} din {totalRecords} rapoarte"
  paginatorPosition="both"
  [first]="((filtersForm.value.page ?? 1) - 1) * (filtersForm.value.pageSize ?? 25)"
  [totalRecords]="totalCount()"
  [lazy]="true"
  [value]="data()"
  [paginator]="true"
  [rows]="(filtersForm.get('pageSize')?.value ?? 25)"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[25, 50, 100]"
  (onPage)="pageChanged($event)"
>
  <ng-template pTemplate="header">
    @if (loading()) {
      <tr>
        <td colspan="6">
          <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" />
        </td>
      </tr>
    }
    <tr>
      <th>Agent</th>
      <th>Locker</th>
      <th>Perioadă activitate</th>
      <th class="text-center">Colete expirate preluate</th>
      <th class="text-center">Colete preluate</th>
      <th class="text-center">Colete livrate</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-element>
    <tr class="cursor-pointer hover:surface-100 transition-colors transition-100 transition-ease-in-out" (click)="openSessionInfo(element)">
      <td>
        <p class="text-xs text-gray-400 m-0">{{ element.agent.identifier }}</p>
        <b class="text-lg">{{ element.agent.name }}</b>
        <p class="text-xs m-0">
          {{ element.agent.phone }}
          @if (element.agent.email) {
            <span>
              &#x2022;
              {{ element.agent.email }}
            </span>
          }
        </p>
      </td>
      <td>
        <div class="flex flex-column">
          <div>
            <small class="text-gray-400 text-xs">#{{ element.locker.identifier }}</small><br>
            <b>{{ element.locker.name }}</b>
            <br>
            <small>{{ lockerCleanAddress(element.locker.addressParts) }}</small>
          </div>
        </div>
      </td>
      <td>
        @let activityStart = element.activity.start;
        @let activityEnd = element.activity.end;
        @if (activityStart) {
          <span class="m-0">
            {{ activityStart | date: 'dd MMMM HH:mm:ss' }}
          </span>
        } @else {
          necunoscut
        } - @if (activityEnd) {
          <span class="m-0">
            {{ activityEnd | date: 'dd MMMM HH:mm:ss' }}
          </span>
        } @else {
          necunoscut
        }
      </td>
      <td class="text-center">
        {{ getActionParcelCount(element, agentActions.COURIER_RETRIEVE_EXPIRED) }}
      </td>
      <td class="text-center">
        {{ getActionParcelCount(element, agentActions.COURIER_TAKE_ORDERS) }}
      </td>
      <td class="text-center">
        {{ getActionParcelCount(element, agentActions.COURIER_PUT_ORDERS) }}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
      @if (!loading()) {
      <tr>
        <td colspan="6">
          <p class="text-center text-gray-400 text-xl font-bold">Nu există rapoarte</p>
        </td>
      </tr>
    }
  </ng-template>
</p-table>